import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { Loader, Text, tokens } from '@hotjar/hotsauce';
import type { ReactElement } from 'react';
import { toDataURL } from 'qrcode';
import { useTranslationWithPrefix } from '@hotjar/translations';

const StyledLoader = styled(Loader)`
  margin-top: ${tokens.spacer.x5};
`;

const StyledQRCode = styled.img<{ width?: string }>`
  width: ${(props) => (props.width ? props.width : '50%')};
  margin: 0 auto;
  display: block;
`;

const StyledError = styled(Text)`
  display: block;
  margin-top: ${tokens.spacer.x1};
`;

interface MfaQRCodeProps {
  uri: string;
  hasErrors: boolean;
  isLoading: boolean;
  width?: string;
}

export const MfaQRCode = ({ uri, isLoading, hasErrors, width }: MfaQRCodeProps): ReactElement => {
  const { t } = useTranslationWithPrefix('mfa:enable-modal.qr-code');

  const [qrCodeData, setQrCodeData] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;
    if (uri) {
      toDataURL(uri).then((data: string) => {
        if (!isMounted) {
          return;
        }
        setQrCodeData(data);
      });
    }
    return () => {
      isMounted = false;
    };
  }, [uri]);

  return (
    <>
      <StyledLoader size="xl" isLoading={isLoading}>
        {qrCodeData && (
          <StyledQRCode data-testid="qrcode-img" src={qrCodeData} width={width} alt="QR code" />
        )}
      </StyledLoader>
      {hasErrors && <StyledError textColor="text_error">{t('error-loading-qr-code')}</StyledError>}
    </>
  );
};
